exports.uri = "https://main-server-upwork.herokuapp.com/api/";
// || 'https://merchantbackend.herokuapp.com/api/'
